<template>
  <div>
    <vx-card class="mb-base">
      <vs-table :max-items="5" pagination :data="eventOrders" search>
        <template slot="header">
          <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
            {{ $t("customers.label.on_demand") }}
          </div>
          <span class="order-1">
            <vs-button
              icon-pack="feather"
              icon="icon-plus"
              @click="handleAddEventOrder"
              size="small"
              >{{ $t("customers.label.add_event_order") }}</vs-button
            >
          </span>
        </template>
        <template slot="thead">
          <vs-th>{{ $t("customers.label.event_name") }}</vs-th>
          <vs-th>{{ $t("customers.label.booked_date") }}</vs-th>
          <vs-th>{{ $t("customers.label.charge_code") }}</vs-th>
          <vs-th>{{ $t("customers.label.event_price") }}</vs-th>
          <vs-th>{{ $t("customers.label.status") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].eventName">{{
              data[indextr].eventName
            }}</vs-td>

            <vs-td :data="data[indextr].bookedDate">{{
              data[indextr].bookedDate
            }}</vs-td>
            <vs-td :data="data[indextr].chargecode">{{
              data[indextr].chargecode
            }}</vs-td>

            <vs-td :data="data[indextr].eventPrice">{{
              data[indextr].eventPrice
            }}</vs-td>
            <vs-td :data="data[indextr].status">
              <vs-chip
                :color="getOrderStatusColor(data[indextr].status)"
                class="product-order-status"
                >{{ data[indextr].status }}</vs-chip
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="centerx">
      <vs-popup
        :title="$t('customers.label.event_order')"
        :active.sync="eventOrderCreatePopup"
        class="popup-close mid-popup"
      >
        <ValidationObserver ref="observer">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold"
                  >{{ $t("customers.label.eventdate")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.eventdate')"
                  :key="resetKey"
                >
                  <datepicker
                    name="start-date"
                    v-model="eventDate"
                    :label="$t('customers.label.eventdate')"
                  ></datepicker>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold"
                  >{{ $t("customers.label.events")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.events')"
                  :key="resetKey"
                >
                  <v-select
                    label="eventName"
                    v-model="eventId"
                    :options="networkEleData.events"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('customers.label.SelectEvents')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold"
                  >{{ $t("customers.label.format_type")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.format_type')"
                  :key="resetKey"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="formatType"
                    :options="networkEleData.codes"
                    :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                    :placeholder="$t('customers.label.SelectFormatType')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold"
                  >{{ $t("customers.label.opt_type")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.card_number')"
                  :key="resetKey"
                >
                  <v-select
                    label="value"
                    v-model="optType"
                    :options="networkEleData.optType"
                    :reduce="(value) => value.value"
                    :placeholder="$t('customers.label.Select_OPT_Type')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row">
              <span class="ml-4 mr-1">
                <vs-button type="border">{{
                  $t("customers.label.clear")
                }}</vs-button>
              </span>
              <span class="ml-1 mr-2">
                <vs-button @click="createEvent()">{{
                  $t("customers.label.submit")
                }}</vs-button>
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import moment from "moment";
export default {
  props: ["clientId"],
  data() {
    return {
      eventOrderCreatePopup: false,
      OnDemand: [],
      resetKey: 0,
      networkEleData: {},
      eventId: "",
      formatType: "",
      optType: "",
      eventDate: moment().format("DD MMMM YYYY"),
      dateFormat: "dd MMMM yyyy",
    };
  },
  computed: {
    eventOrders() {
      return this.$store.getters["customerOnDemand/GetClientEventOrders"];
    },
    eventTemplate() {
      return this.$store.getters["customerOnDemand/GetEventOrdersTemplate"];
    },
  },
  methods: {
    async getEventOrders() {
      try {
        await this.$store.dispatch(
          "customerOnDemand/getEventOrderByClientAction",
          this.clientId
        );
      } catch (e) {
        console.log(
          "Something went wrong while retrieving event order for client: ",
          e
        );
      }
    },
    handleAddEventOrder() {
      this.resetKey++;
      this.eventOrderCreatePopup = true;
    },
    async getEventOrderTemplate() {
      try {
        await this.$store.dispatch(
          "customerOnDemand/clientEventOrderTemplateAction",
          this.clientId
        );
        this.networkEleData = this.eventTemplate;
      } catch (e) {
        console.log(
          "Something went wrong while retrieving event order for client: ",
          e
        );
      }
    },
    async createEvent() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        clientId: this.clientId,
        eventId: this.eventId,
        formatType: this.formatType,
        optType: this.optType,
        // eventBookedDate: this.dateFormat,
        eventBookedDate: (this.eventDate = moment(this.eventDate).format(
          "DD MMMM YYYY"
        )),
        dateFormat: "dd MMMM yyyy",
        locale: "en",
      };
      await this.$store.dispatch("customerOnDemand/createEventOrderAction", payload);
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Event Order Created Successfully!",
        type: "success",
      });
    },
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.getEventOrders();
  },
  watch: {
    eventOrderCreatePopup(newValue) {
      if (newValue) this.getEventOrderTemplate();
    },
  },
};
</script>
<style lang="scss" scoped></style>
